import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=6046a510"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports